export const RE_ACTIVATION_SUCCEED = '@@mah-maps/RE_ACTIVATION_SUCCEED';
export const RE_ACTIVATION_FAILED = '@@mah-maps/RE_ACTIVATION_FAILED';
